/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { SPACING_S } from '@veeam/components';

import type { CSSProperties } from 'react';

import { FieldsetSectionRow } from '../FieldsetSectionRow';

import type { FieldsetSectionRowProps } from '../FieldsetSectionRow';

export interface FieldsetSectionGridProps {
    items: FieldsetSectionRowProps[];
    itemsStyles?: CSSProperties;
}

export const FieldsetSectionGrid: React.FC<FieldsetSectionGridProps> = ({ items, itemsStyles }) => (
    <div
        style={{
            display: 'grid',
            gridGap: `${SPACING_S}`,
            gridTemplateColumns: 'repeat(2, minmax(10px, max-content))',
            ...itemsStyles,
        }}
    >
        {items.map((item, index) => <FieldsetSectionRow key={`FieldsetSectionRow-${index}`} {...item} />)}
    </div>
);
